import { useMemo, useState } from "react";
import { Title } from "react-migration/domains/ownership/typings/Title";
import { TransactionPurchaseType } from "react-migration/domains/ownership/typings/Transaction";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { isDefined } from "react-migration/lib/util/isDefined";
import { PRICE_PER_TITLE_GBP } from "src/js/util/units_and_constants";
import { PurchaseTitle } from "./PurchaseTitle";
import { PurchaseTitleModal, PurchaseLocations } from "./PurchaseTitleModal";
import { uniqueTitlesById } from "./useTitleFeatures";

export function PurchaseAllTitles({ titles }: { titles: Title[] }) {
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const { t } = useTranslation();

  const titlesToPurchase = useMemo(
    () =>
      uniqueTitlesById(titles)
        .map((title) => title.title_no)
        .filter(isDefined),
    [titles]
  );

  return (
    <>
      <div className="p-2">
        <div className="mb-3 text-sm font-semibold text-text-base-tertiary">
          {t("ownership.titles_section.purchase_all_titles")}
        </div>
        <div className="flex gap-2">
          <div className="flex-1">
            <PurchaseTitle.Wrapper icon="icon-lt-file-line" className="bg-platform-blue-50">
              <PurchaseTitle.Heading>{t("ownership.titles_section.title_register")}</PurchaseTitle.Heading>
              <PurchaseTitle.Price onClick={() => setShowRegisterModal(true)}>
                {t("ownership.titles_section.purchase_all_for_price", {
                  price: titlesToPurchase.length * PRICE_PER_TITLE_GBP,
                })}
              </PurchaseTitle.Price>
            </PurchaseTitle.Wrapper>
          </div>
          <div className="flex-1">
            <PurchaseTitle.Wrapper icon="icon-lt-file-line" className="bg-platform-blue-50">
              <PurchaseTitle.Heading>{t("ownership.titles_section.title_plan")}</PurchaseTitle.Heading>
              <PurchaseTitle.Price onClick={() => setShowPlanModal(true)}>
                {t("ownership.titles_section.purchase_all_for_price", {
                  price: titlesToPurchase.length * PRICE_PER_TITLE_GBP,
                })}
              </PurchaseTitle.Price>
            </PurchaseTitle.Wrapper>
          </div>
        </div>
      </div>
      {showRegisterModal && (
        <PurchaseTitleModal
          title={t("ownership.titles_section.purchase_title_register_multiple")}
          titlesToPurchase={titlesToPurchase}
          onCancel={() => setShowRegisterModal(false)}
          transactionPurchaseType={TransactionPurchaseType.TITLE_REGISTER_DOCUMENT}
          location={PurchaseLocations.Map}
        />
      )}
      {showPlanModal && (
        <PurchaseTitleModal
          title={t("ownership.titles_section.purchase_title_plan_multiple")}
          titlesToPurchase={titlesToPurchase}
          onCancel={() => setShowPlanModal(false)}
          transactionPurchaseType={TransactionPurchaseType.TITLE_PLAN_DOCUMENT}
          location={PurchaseLocations.Map}
        />
      )}
    </>
  );
}
